export enum ERole {
  Doctor = 'Doctor',
  Manager = 'Manager',
}
